import React from 'react';

const LocationIcon = ({ id, className, color, styles }) => {
	const colorMap = {
		cdgr: '#5B5855',
		cgrn: '#0C4A34',
		cw: '#FFFFFF',
		cbb: '#3477AC',
	};

	return (
		<div id={id} className={className} style={styles}>
			<svg
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
			>
				<path
					d='M12 3C8.68286 3 6 5.817 6 9.3C6 14.025 12 21 12 21C12 21 18 14.025 18 9.3C18 5.817 15.3171 3 12 3Z'
					stroke={`${colorMap[color] || '#B0ACA3'}`}
					strokeWidth='2'
				/>
				<circle
					cx='12'
					cy='9'
					r='2'
					stroke={`${colorMap[color] || '#B0ACA3'}`}
					strokeWidth='2'
				/>
			</svg>
		</div>
	);
};

export default LocationIcon;
